// @flow
import * as React from 'react';

type Props = {|
  className: string,
  name: string,
  width: string,
  height: string
|};

class Icon extends React.PureComponent<Props> {
  static defaultProps = {
    className: ''
  };

  render() {
    const { className = '', name, width, height } = this.props;

    return (
      <svg className={`svg-sprite ${className}`} width={width} height={height}>
        <use xlinkHref={`${window.serverData._uri}/public/images/shapes.svg#${name}`} />
      </svg>
    );
  }
}

export default Icon;
